import { Stack, Box, Typography, Button, ButtonGroup, Tooltip } from '@mui/material';
import { RichTreeView, TreeItem } from '@mui/x-tree-view';
import { boxStyle } from './MetricChart/util';
import Markdown from 'react-markdown';
import PropTypes from 'prop-types';
import RefreshIcon from '@mui/icons-material/Refresh';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { useCanAccess } from 'react-admin';

const summaryStyle = {
	border: 'solid black 2px',
	padding: 2,
	marginLeft: 6
};

const renderLabel = (props) => {
	if ( 0 === props.itemId.indexOf( '_SUMMARY_' ) ) {
		return (
			<Box {...summaryStyle}>
				<Markdown>{props.label}</Markdown>
			</Box>
		);
	}

	return <TreeItem {...props} />;
};

export const SummaryList = (props) => {
	const { data, onRefresh } = props;
	const summaryItems = data ? data : [];

	const handleRefresh = () => {
		onRefresh()
	};

	const handleForceRefresh = () => {
		onRefresh(true);
	};

	const RefreshButtons = () => {
		
		const { canAccess, isPending } = useCanAccess({ action: 'create', resource: 'summaries' });

		return !isPending && canAccess && onRefresh ? (
			<ButtonGroup variant="outlined" size="small">
				<Tooltip title="Refresh summaries with new transcripts">
					<Button onClick={handleRefresh} startIcon={<RefreshIcon />}>
						Refresh
					</Button>
				</Tooltip>
				<Tooltip title="Force regenerate all summaries with available transcripts">
					<Button onClick={handleForceRefresh} startIcon={<AutorenewIcon />}>
						Force Refresh
					</Button>
				</Tooltip>
			</ButtonGroup>
		) : null;
	}

	return (
		<Stack direction={{ sm: 'column', md: 'row' }} spacing={2} alignItems={"stretch"} marginTop={2}>
			<Box {...boxStyle} width={1}>
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
					<Typography variant="h5">Summaries</Typography>
					<RefreshButtons onRefresh={onRefresh} />
				</Box>
				<RichTreeView
					items={summaryItems}
					slots={{ item: renderLabel }} />
			</Box>
		</Stack>
	);
};

SummaryList.propTypes = {
	data: PropTypes.array,
	onRefresh: PropTypes.func
};

export default SummaryList;
